<template>
    <div class="option-wrap"
         ref="options">
        <div class="options"
        >
            <slot></slot>
        </div>
    </div>
</template>

<script>
  export default {
    mounted() {
      window.addEventListener('scroll', this.lsScroll);
    },
    destroyed() {
      window.removeEventListener('scroll', this.lsScroll);
    },
    methods: {
      lsScroll: function () {
        this.$nextTick(() => {
          let topScroll = document.body.scrollTop || document.documentElement.scrollTop;
          this.$refs.options.querySelector(".options").style.top = topScroll + 'px';
        });
      }
    }
  }
</script>